export default {"src":"/_next/static/media/shipping8.15627165.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};